<template>
  <nav class="header">
    <div class="header__brand">
      <router-link :to="{ path: '/' }">
        <img v-if="hasLogo" class="navbar-brand header__logo" :src="userLogo"/>
        <img v-else class="navbar-brand header__logo" src="../../assets/logo.svg"/>
      </router-link>
    </div>
    <nav-bar v-if="isLoggedIn" :is-admin="isAdmin" :is-client-admin="isClientAdmin" :is-client="isClient" :is-editor="isEditor" :is-render-manager="isRenderManager" />
    <ul v-if="isLoggedIn" class="header__menu">
      <li class="header__menuItem">
        <router-link :to="{ path: '/help' }" class="header__menuLink">
          <i class="header__menuIcon fa fa-question-circle"></i>
          <span>Help</span>
        </router-link>
      </li>
      <li class="header__menuItem">
        <a href="https://support.otomo.io/support/home" class="header__menuLink" target="_blank">
          <i class="header__menuIcon fa fa-life-ring"></i>
          <span>Support</span>
        </a>
      </li>
      <li class="header__menuItem btn-group">
        <a href="#" class="header__menuLink header__menuLink--toggle" @click.prevent="toggleDropdown">
          <i class="header__menuIcon fa fa-user"></i>
          <span>{{ profileUserProp }}</span>
        </a>
        <div :class="`header__dropdown${showDropdown ? ' header__dropdown--open' : ''}`">
          <a @click.prevent="goToLink()" class="header__dropdownItem" href="#">My Profile</a>
          <a @click="logout" class="header__dropdownItem" href="#">Log Out</a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { API_URL } from '@/config'
import SearchBox from '@/components/SearchBox/searchbox'
import NavBar from '@/components/NavBar/nav-bar'

import ls from 'local-storage'
import {DEFAULT_JWT_TOKEN_STORE_KEY} from '../../store/modules/auth'
import Vue from 'vue'

import {profileMixin} from '@/mixins/profileMixin'

export default {
  name: 'Header',
  mixins: [profileMixin],
  components: {
    SearchBox,
    NavBar
  },
  props: {
    profileUserProp: String,
    isAdmin: Boolean,
    isClientAdmin: Boolean,
    isClient: Boolean,
    isEditor: Boolean,
    isRenderManager: true
  },
  mounted () {},
  data: () => ({
    showDropdown: false
  }),
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    goToLink () {
      this.toggleDropdown()
      this.$router.push({ name: 'Profile' })
    },
    logout () {
      this.toggleDropdown()
      ls.remove('ot-user')
      ls.remove(DEFAULT_JWT_TOKEN_STORE_KEY)
      Vue.http.headers.common['X-Authorization'] = null
      this.$store.commit('profile/setCurrentUser', null)
      this.$router.push({ name: 'Login' })
    }
  },
  computed: {
    isLoggedIn () {
      return !!this.profileUser
    },
    userLogo () {
      return API_URL + this.profileUser.logo.substring(1)
    },
    hasLogo () {
      return this.profileUser && this.profileUser.logo && this.profileUser.logo.length > 0
    }
  }
}
</script>

<style lang="scss">
    @import "../../scss/variables";
    @import "./header";
    .header {
      margin-bottom: 0;
      max-height: 71px;
      display: flex;
      align-items: center;
      background-color: #2c3247;
      border-bottom: 3px solid #56ffa2;
      &__logo {
        min-height: 65px;
        padding: 15px 30px;
      }
      &__menu {
        list-style: none;
        margin: 0 0 0 auto;
        padding: 0 15px 0 0;
      }
      &__menuItem {
        display: inline-block;
        margin-left: 15px;
        &.btn-group {
          vertical-align: baseline
        }
      }
      &__dropdown {
        position: absolute;
        top: 100%;
        right: 15px;
        z-index: 1000;
        float: left;
        display: none;
        min-width: 10rem;
        padding: .5rem 0;
        margin: .125rem 0 0;
        color: #292b2c;
        text-align: left;
        list-style: none;
        background-color: #fff;
        -webkit-background-clip: padding-box;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: .25rem;
        font-size: 14px;
        &--open {
          display: block;
        }
      }
      &__dropdownItem {
        display: block;
        width: 100%;
        padding: 5px 30px;
        clear: both;
        font-weight: 400;
        color: #292b2c;
        text-align: inherit;
        white-space: nowrap;
        background: 0 0;
        border: 0;
        text-decoration: none;
        color: #000;
        &:hover {
          text-decoration: underline;
        }
      }
      &__menuLink {
        color: #DDD;
        display: flex;
        align-items: baseline;
        transition: all $transition;
        &--toggle {
          padding-right: 30px;
          &:after {
            position: absolute;
            right: 15px;
            top: 50%;
            display: inline-block;
            width: 0;
            height: 0;
            margin-left: .3em;
            vertical-align: middle;
            content: "";
            border-top: .3em solid;
            border-right: .3em solid transparent;
            border-left: .3em solid transparent;
          }
        }
        &:hover, &:focus {
          text-decoration: none;
          color: #FFF;
          .header__menuIcon {
            color: #FFF
          }
        }
      }
      &__menuIcon {
        color: $brand;
        font-size: 20px !important;
        margin-right: 7px;
      }
      &__search {
        position: absolute;
        left: 280px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header/header.vue